
// Modified version of the link below, to be made in-place
// https://stackoverflow.com/a/65496148/
export function inplaceKeySort(items, key, reverse = false) {
	if( items.length == 0 ) return items;
	const sortKeys = items.map((item, pos) => [key(item), pos]);
	const comparator =
		Array.isArray(sortKeys[0][0])
		? ((left, right) => {
			left = left[0]; right = right[0];
			for (var n = 0; n < Math.min(left.length, right.length); n++) {
				const vLeft = left[n], vRight = right[n];
				const order = vLeft == vRight ? 0 : (vLeft > vRight ? 1 : -1);
				if (order != 0) return order;
			}
			return left.length - right.length;
		})
		: ((left, right) => {
			const vLeft = left[0], vRight = right[0];
			const order = vLeft == vRight ? 0 : (vLeft > vRight ? 1 : -1);
			return order;
		});

	sortKeys.sort(comparator);
	if (reverse) sortKeys.reverse();

	let sorted = sortKeys.map((order) => items[order[1]]);

	//Inplace Stuff!
	items.splice(0);
	items.push( ...sorted );
	return items;
}

export function generateUUID4(){
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
		/[xy]/g, (c) => {
			var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		}
	)
}

export const delay = (ms: number): Promise<void> => new Promise(resolve => setTimeout(resolve, ms));


export function getLogoSrcOf( key ){
	const dir_path = "/assets/official-logos/";
	const known_logos = {
		"espn":"espn-plus.svg",
		"espn+":"espn-plus.svg",
		"espn_plus":"espn-plus.svg",
		"nbc":"nbc.svg",

		"apple":"apple.svg",
		"apple_tv":"apple.svg",

		"dazn":"dazn.svg",

		"sportsnet":"sportsnet.svg",
		"sn":"sportsnet.svg",

		"peacock":"peacock.svg",

		//Sport Specific
		"nhl":"nhl.svg",
		"nhl_network":"nhl-network.svg",
		"nhl_net":"nhl-network.svg",

		"mlb":"mlb.svg",
		"mlb_network":"mlb-network.svg",

		"nfl_network":"nfl-network.svg",
		"nfl_redzone":"nfl-redzone.svg",
		"redzone":"nfl-redzone.svg",
		"nfl_redzone_white":"nfl-redzone-white.svg",

		"nba":"nba.svg",
		"nba_tv":"nba-tv.svg",
	};

	let match = known_logos[key.toLowerCase().replace(/_|-|\s/g,"_")];
	if( !match ) return;
	return dir_path + match;
}
